import { ModuleIntegration } from 'data/terra/ModuleIntegration';

export const FETCH_MODULE_INTEGRATIONS_RESULT =
  'FETCH_MODULE_INTEGRATIONS_RESULT';

export interface FetchIntegrationResultAction {
  type: typeof FETCH_MODULE_INTEGRATIONS_RESULT;
  integrations: ModuleIntegration[];
  integrationsOfSelectedEnv: ModuleIntegration[];
}

export type ModuleAction = FetchIntegrationResultAction;
